import { render, staticRenderFns } from "./_remapLeague.vue?vue&type=template&id=1141afdb&scoped=true&lang=pug&"
import script from "./_remapLeague.vue?vue&type=script&lang=js&"
export * from "./_remapLeague.vue?vue&type=script&lang=js&"
import style0 from "./_remapLeague.vue?vue&type=style&index=0&id=1141afdb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1141afdb",
  null
  
)

export default component.exports